<template>
  <v-container fill-height>
    <v-row align="center" class="fill-height ma-0" justify="center">
      <Logo />
    </v-row>
    <v-row>
      <v-col> </v-col>
      <v-col align="center" class="lg-6">
        <v-form class="mt-10">
          <v-row>
            <v-text-field v-model.trim="username" name="Username" persistent-placeholder
              :placeholder="$t('Login.Username')"></v-text-field>
          </v-row>
          <v-row>
            <v-text-field v-model.trim="password" name="Password" persistent-placeholder :placeholder="$t('Login.Password')"
              type="password" @keyup.enter="submit"></v-text-field>
          </v-row>

          <v-row>
            <div v-if="loginFailed" class="red--text mb-2">
              {{ $t('Login.YourUsernameOrPasswordIsIncorrect') }}
            </div>
            <div v-if="facilityLoginFailed" class="red--text mb-2 text-left">
              {{ $t('Login.YourAreNotAssignedToAnyFacilityPleaseContactSupport') }}
              <a href="mailto:support@getreshub.com">support@getreshub.com</a> {{ $t('Login.ClickToGetAssistance') }}
            </div>
            <div v-if="maintenanceUserFailed" class="red--text mb-2 text-left">
              {{ $t('Login.YouHaveInsufficientPermissionsToLogIntoStaffHub') }}
            </div>
          </v-row>
          <v-row class="py-3">
            <p class="text-center w-100">
              <router-link class="black--text font-weight-bold text-decoration-none" to="/login/forgot-password">{{$t('Login.ForgotPasswordQuestion')}}</router-link>
            </p>
          </v-row>
          <v-row>
            <v-btn block class="primary" large @click="submit" :loading="loading">{{$t('Login.SignIn')}}</v-btn>
          </v-row>
        </v-form>
      </v-col>

      <v-col> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Logo from "./Logo.vue";

export default {
  components: {
    Logo
  },
  data() {
    return {
      username: "",
      password: "",
      rememberMe: true,
      error: null,
      loading: false
    };
  },
  computed: {
    ...mapState({
      facilityLoginFailed: state => state.authModule.facilityLoginFailed,
      loginFailed: state => state.authModule.loginFailed,
      maintenanceUserFailed: state => state.authModule.maintenanceUserFailed
    })
  },
  created() {
    this.$store.dispatch("resetFailures");
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store.dispatch("userSignIn", {
        email: this.username.trim(),
        password: this.password.trim()
      }).then((isSuccess) => {
        if (isSuccess === false && this.loginFailed) {
          throw new Error(this.$t('Login.LoginFaildForUser') + this.username);
        }
        else if (isSuccess === false && this.facilityLoginFailed) {
          throw new Error(this.$t('Login.NoAnyFacilityAssigned') + this.username);
        }

      }).finally(()=>{
        this.loading = false;
      })
    }
  }
};
</script>
